import { BASE_API } from "../utils/constants";

export async function getOffersApi(onlyActive = false) {
  try {
    const activeFilter = onlyActive ? "?active=true" : "";
    const url = `${BASE_API}/api/offers/${activeFilter}`;
    const response = await fetch(url);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function addOfferApi(data, token) {
  try {
    const url = `${BASE_API}/api/offers/`;
    const params = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function updateOfferApi(id, data, token) {
  try {
    const url = `${BASE_API}/api/offers/${id}/`;
    const params = {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(data),
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}

export async function deleteOfferApi(id, token) {
  try {
    const url = `${BASE_API}/api/offers/${id}/`;
    const params = {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const response = await fetch(url, params);
    const result = await response.json();
    return result;
  } catch (error) {
    throw error;
  }
}
